import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { ActionState, BaseComponentConfig, ComponentConfig, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { options } from './configOptions';

@Component({
  selector: 'ngx-marketing',
  templateUrl: './marketing.component.html',
  styleUrls: ['./marketing.component.scss']
})
export class MarketingComponent extends BaseComponentConfig implements OnInit{
  
  constructor(viewContainerService:ViewContainersService,
      menuService:NbMenuService,
      configurationService:ConfigurationService,
      route:ActivatedRoute,
      updateComponentStoreService:UpdateComponentStoreService,
      router:Router) {
      super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService);
      
     }
  ngOnInit(): void {
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
    options.defaultAction = ActionState.LIST;
    this.componentConfig = new ComponentConfig(options);
  }
}
